import React, { useCallback } from 'react';

import { ClassName, GADataType, I18nText } from '../../../../../../../types';
import { IconsEnum } from '../../../../../../../assets/icons/types';

import {
  LifestyleID,
  LifestyleImageFile,
  LifestyleImageID,
  LifestyleImageUUID,
  OnLifestyleSimilarSearchAction
} from '../../../../../../lifestyles/lifestylesTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';

import { aiSearchKeys } from '../../../../../../../locales/keys';

interface ThreeDStockLifestylesListItemSimilarSearchButtonLifestyle {
  id: LifestyleID;
  image: {
    id: LifestyleImageID;
    uuid: LifestyleImageUUID;
    file: LifestyleImageFile;
  };
}

interface ThreeDStockLifestylesListItemSimilarSearchButtonProps {
  onLifestyleSimilarSearch?: OnLifestyleSimilarSearchAction;
  lifestyle: ThreeDStockLifestylesListItemSimilarSearchButtonLifestyle;
  className?: ClassName;
  i18nText?: I18nText;
  i18nTextClassName?: ClassName;
  icon?: IconsEnum;
  onAfterClick?: () => void;
}

function ThreeDStockLifestylesListItemSimilarSearchButton({
  dataGa,
  onLifestyleSimilarSearch,
  lifestyle,
  className,
  i18nText,
  i18nTextClassName,
  icon = IconsEnum.PHOTO_SOLID,
  onAfterClick
}: ThreeDStockLifestylesListItemSimilarSearchButtonProps & GADataType) {
  const handleLifestyleSimilarSearch = useCallback<() => void>(() => {
    onLifestyleSimilarSearch?.(lifestyle);
    onAfterClick?.();
  }, [lifestyle, onLifestyleSimilarSearch, onAfterClick]);

  return (
    <PureTooltipIconButtonHelper
      className={
        className ||
        'bg-white dark:bg-gray-900 dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0 font-medium hover:bg-gray-200 inline-flex items-center p-1 rounded-md text-gray-700 text-sm pointer-events-auto shadow dark:glow'
      }
      dataGa={dataGa}
      icon={icon}
      iconClassName="h-5 w-5"
      i18nText={i18nText}
      i18nTextClassName={i18nTextClassName}
      onClick={handleLifestyleSimilarSearch}
      tooltipI18nText={i18nText ? null : aiSearchKeys.findSimilar}
      tooltipSingleton
    />
  );
}

export default ThreeDStockLifestylesListItemSimilarSearchButton;
